export const faqs = [
  {
    question: 'Čo je PWA a prečo ju zvážiť?',
    answer:
      'PWA (Progressive Web App) je webová aplikácia, ktorá sa správa ako natívna. Funguje offline, inštaluje sa jedným klikom bez App Storu a nepotrebuje samostatný kód pre iOS a Android — čo výrazne šetrí náklady.',
  },
  {
    question: 'Ako funguje Gemini Multimodal Embeddings?',
    answer:
      'Je to AI technológia od Googlu, ktorá naraz spracuje text, obraz, video a zvuk. Vytvára jednotný „odtlačok významu", vďaka čomu viete napríklad vyhľadávať vo videách textom.',
  },
  {
    question: 'Koľko stojí vývoj PWA aplikácie?',
    answer:
      'Cena závisí od rozsahu. Vďaka modulárnemu prístupu a hotovým AI modelom dodáme MVP za zlomok ceny tradičného vývoja. Presnú kalkuláciu pripravíme po bezplatnej konzultácii.',
  },
  {
    question: 'Ako dlho trvá vývoj?',
    answer:
      'Pracujeme v 14-dňových šprintoch. Prvú fungujúcu verziu (MVP) dodávame zvyčajne do 4 až 8 týždňov a potom ju vylepšujeme podľa spätnej väzby používateľov.',
  },
  {
    question: 'Funguje PWA offline?',
    answer:
      'Áno. Service Workers ukladajú dáta do zariadenia, takže s aplikáciou viete pracovať aj bez internetu. Po obnovení pripojenia sa dáta automaticky zosynchronizujú.',
  },
  {
    question: 'Aké technológie používate?',
    answer:
      'React a TypeScript pre frontend, Tailwind CSS pre dizajn a Google Gemini pre AI funkcie. Všetko optimalizované na výkon a bezpečnosť.',
  },
]
